window.$ = window.jQuery = require('jquery');
import { gsap } from 'gsap';

export function ToggleDrawer() {
$(function () {
    const toggleDrawerButtons = document.querySelectorAll(
        '[data-toggle-drawer]'
    );
    const drawers = document.querySelectorAll('[data-drawer-name]');
    const mm = window.matchMedia('(min-width:1100px)');
    mm.addListener(e => {
        if (mm.matches) {
            for (const button of toggleDrawerButtons) {
                button.setAttribute('aria-expanded', false);
            }
            for (const drawer of drawers) {
                drawer.setAttribute('aria-hidden', true);
            }
        }
    });

    $('[data-toggle-drawer]').on('click', e => {
        e.preventDefault();

        const target = document.querySelector(
            `[data-drawer-name="${e.currentTarget.dataset.targetDrawer}"]`
        );

        const expanded =
            e.currentTarget.getAttribute('aria-expanded') === 'true';
        e.currentTarget.setAttribute('aria-expanded', !expanded);

        if (expanded) {
            gsap.killTweensOf(target);
            gsap.to(target, {
                transform: `translateX(-100%)`,
                duration: 0.3,
                onComplete: () => {
                    target.setAttribute('aria-hidden', true);
                }
            });
        } else {
            target.setAttribute('aria-hidden', false);
            gsap.killTweensOf(target);
            gsap.fromTo(
                target,
                { transform: `translateX(-100%)` },
                { transform: `translateX(0%)`, duration: 0.3 }
            );
        }
    });
});
}